import React from "react";
import clsx from "clsx";
import AddButtonNew from "../AddButton/AddButtonNew";
import OrderableList from "../OrderableList/OrderableList";

export default class RoleBuilderDashboards extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    var tabClasses = clsx({
      'active': this.props.active_tab == 'dashboards',
      'tab-pane': true
    });

    var dashboards = this.props.roleDashboards.map((roleDashboard) => { return{ position: roleDashboard.position, name: roleDashboard.dashboard.name, id: roleDashboard.dashboard.id}});

    return(
      <div className={tabClasses}>
        {
          this.props.read_only && !this.props.allow_edit_dashboard
          ?
          this.renderReadOnly(dashboards)
          :
          this.renderForm(dashboards)
        }
      </div>
    );
  };

  renderForm(dashboards) {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default" style={{ marginBottom: 0 }}>
            <div className="panel-heading">
              <div>
                {
                  <div className="row content-right add-row">
                    <AddButtonNew
                      disabled={this.props.disabled}
                      new_button={false}
                      model="Dashboard"
                      text={I18n.t('add')}
                      ids={this.props.roleDashboards ? this.props.roleDashboards.map((RoleDashboard) => { return RoleDashboard.dashboard.id}) : null}
                      onAdd={this.props.onAddDashboard}
                      buttonClasses="btn btn-default btn-secondary"
                      generalPosition="left"
                    />
                    {/* <AddButton
                      disabled={this.props.disabled}
                      new_button={false}
                      model="Dashboard"
                      text={I18n.t('add')}
                      ids={this.props.roleDashboards ? this.props.roleDashboards.map((RoleDashboard) => { return RoleDashboard.dashboard.id}) : null}
                      onAdd={this.props.onAddDashboard}
                      buttonClasses="btn btn-default"
                    /> */}
                </div>
              }
            </div>
            {
              dashboards.length
              ?
                <OrderableList
                  helperText='guest_type_order_helper_text'
                  onChange={this.props.onChangeDashboardPosition}
                  allInputs={dashboards}
                  onRemove={this.props.onRemoveDashBoard}
                  read_only={this.props.allow_edit_dashboard ? false : this.props.read_only}
                  />
              :
              <div className="no-records"><span className="none">{I18n.t('none')}</span></div>
            }
          </div>
        </div>
      </div>
      </div>
    );
  };

  renderReadOnly(dashboards) {
    return (
      <ul style={{marginButton: 0}}>
        {dashboards.map((d) => <li key={d.position}>{d.name}</li>)}
      </ul>
    );
  };

};
